import { createSelector } from 'reselect';

const getReducer = (state) => state.createGroupModal;

export const currentStepSelector = createSelector(
  (state) => getReducer(state).currentStep,
  (currentStep) => currentStep
);

export const errorSelector = createSelector(
  (state) => getReducer(state).error,
  (error) => error
);

export const groupIdSelector = createSelector(
  (state) => getReducer(state).groupId,
  (groupId) => groupId
);

export const groupNameSelector = createSelector(
  (state) => getReducer(state).groupName,
  (groupName) => groupName
);

export const groupTypeSelector = createSelector(
  (state) => getReducer(state).groupType,
  (groupType) => groupType
);

export const showSelector = createSelector(
  (state) => getReducer(state).show,
  (show) => show
);

export const showEditSelector = createSelector(
  (state) => getReducer(state).showEdit,
  (showEdit) => showEdit
);
